import Swiper from 'swiper';

const projectsSlider = () => {
    new Swiper('.swiper-container-projects', {
        direction: "horizontal",
        slidesPerView: 'auto',
        loop: false,
    });
};

export { projectsSlider as default };
